export default __webpack_public_path__ + "static/preview-tinyrainboot-21a77bfb570ff64c07def13c7c3aff49.jpg";